exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-bottom .disabled[data-v-07cd64c5]{background:#ccc;color:#000;opacity:.4}.btn-bottom .btn-fix[data-v-07cd64c5]{-webkit-animation:accelerateAnim-data-v-07cd64c5 .1s both;animation:accelerateAnim-data-v-07cd64c5 .1s both}@-webkit-keyframes accelerateAnim-data-v-07cd64c5{0%,to{-webkit-transform:translateZ(0);transform:translateZ(0)}}", ""]);

// exports
